/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum TopTaskType {
  TIME_TO_SUBMISSION = "TIME_TO_SUBMISSION",
  CHECK_IN = "CHECK_IN",
  IDLE_REMINDER = "IDLE_REMINDER",
  CANDIDATE_ISSUE_MISSING_FOCUS_AREA = "CANDIDATE_ISSUE_MISSING_FOCUS_AREA",
  CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE = "CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE",
  CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS = "CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS",
  CANDIDATE_ISSUE_MISSING_PRACTICE_START_YEAR = "CANDIDATE_ISSUE_MISSING_PRACTICE_START_YEAR",
  CANDIDATE_REPUTATION_COACHING_ALERT = "CANDIDATE_REPUTATION_COACHING_ALERT",
  CANDIDATE_REPUTATION_EXPECTATIONS_NOT_MET = "CANDIDATE_REPUTATION_EXPECTATIONS_NOT_MET",
  CANDIDATE_REPUTATION_FEEDBACK = "CANDIDATE_REPUTATION_FEEDBACK",
  COOL_CANDIDATES_ON_CLOSED_OPPORTUNITY = "COOL_CANDIDATES_ON_CLOSED_OPPORTUNITY",
  EXPERIENCE_DESCRIPTION_LENGTH_EXCEPTION = "EXPERIENCE_DESCRIPTION_LENGTH_EXCEPTION",
  SEND_KICKOFF = "SEND_KICKOFF",
}

export const TopTaskTypeDisplay: Record<TopTaskType, string> = {
  [TopTaskType.TIME_TO_SUBMISSION]: "Time To Submission",
  [TopTaskType.CHECK_IN]: "Check In",
  [TopTaskType.IDLE_REMINDER]: "Idle Reminder",
  [TopTaskType.CANDIDATE_ISSUE_MISSING_FOCUS_AREA]: "Candidate Issue Missing Focus Area",
  [TopTaskType.CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE]: "Candidate Issue Missing Business Title",
  [TopTaskType.CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS]: "Candidate Issue Missing Address Fields",
  [TopTaskType.CANDIDATE_ISSUE_MISSING_PRACTICE_START_YEAR]: "Candidate Issue Missing Practice Start Year",
  [TopTaskType.CANDIDATE_REPUTATION_COACHING_ALERT]: "Candidate Reputation Coaching Alert",
  [TopTaskType.CANDIDATE_REPUTATION_EXPECTATIONS_NOT_MET]: "Candidate Reputation Expectations Not Met",
  [TopTaskType.CANDIDATE_REPUTATION_FEEDBACK]: "Candidate Reputation Feedback",
  [TopTaskType.COOL_CANDIDATES_ON_CLOSED_OPPORTUNITY]: "Cool Candidates On Closed Opportunity",
  [TopTaskType.EXPERIENCE_DESCRIPTION_LENGTH_EXCEPTION]: "Experience Description Length Exception",
  [TopTaskType.SEND_KICKOFF]: "Send Kickoff",
};
